import { getCliente } from './getCliente'
import { addClient } from './addClient'
import { updateClient } from './updateClient'
import { getClientWithOpportunities } from './getClientWithOpportunities'
import { getMassiveUploadTemplate } from './getMassiveUploadTemplate'
import { uploadCargaMasivaLeads } from './uploadCargaMasivaLeads'

export const Clients = {
  getCliente,
  addClient,
  updateClient,
  getClientWithOpportunities,
  getMassiveUploadTemplate,
  uploadCargaMasivaLeads
}